import { CmsObjectWithDefault } from '@components/Cms/types';

export type CountrySelectCmsKey = 'countryCodeLabel' | 'selectLabel' | 'searchPlaceHolder';

export const CountrySelectCmsWithDefault: CmsObjectWithDefault<CountrySelectCmsKey> = {
    countryCodeLabel: {
        cmsId: 84706,
        defaultTranslation: 'Country code',
    },
    selectLabel: {
        cmsId: 57106,
        defaultTranslation: 'Select',
    },
    searchPlaceHolder: {
        cmsId: 84709,
        defaultTranslation: 'Enter the country/region name',
    },
};
